export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    start: {
      type: [Number, String],
      required: true,
    },
    end: {
      type: [Number, String],
      required: true,
    },
  },
  inject: ['$vp'],
  methods: {
    onPlay() {
      this.setLiveMessage(this.text);
    },
    currentTime() {
      return this.$vp.currentTime;
    },
  },
  computed: {
    show() {
      return (
        this.videoStarted &&
        this.start <= this.currentTime() &&
        (this.end === 'final' || this.end >= this.currentTime())
      );
    },
    videoStarted() {
      return this.currentTime() > 0;
    },
  },
  watch: {
    show: function () {
      if (this.show === true) {
        this.onPlay();
      }
    },
  },
};
